/**
 * @module Experience/Shop/Order-Confirmation
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const ORDER_CONFIRMATION_COMPONENTS = {
  ORDER_CONFIRMATION_MODULE: 'OrderConfirmationModule',
  ORDER_CONFIRMATION_SERVICE: 'OrderConfirmationService',
  CREDIT: 'CREDIT',
  CASH: 'CASH',
  RETAIN: 'RETAIN',
  REFUND: 'REFUND',
  PURCHASE: 'Purchase',
  DEBIT: 'DEBIT',
  PREPAID: 'PREPAID',
  SEGMENTATION_TOTAL: 'TOTAL',
  SEGMENTATION_TAX_AND_FEE: 'TAX_AND_FEE',
  ACCOUNT_BALANCE_USED: 'DEDUCTIONFROMACCOUNTBALANCE',
  DIRECT_TO_ACCOUNT: 'D2A',
  VOUCHER: 'VOUCHER',
  VOUCHER_REFILL: 'VoucherRefill',
  ORDER_SUMMARY_URL: '/order-summary',
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  TRANSACTION_CONFIRMATION: 'transaction confirmation',
  SHIPPING_LABEL: 'shippingLabel',
  CONFIRMATION_CANCEL: 'Are you sure you want to cancel?',
  CANCELLING_CART:
    'Cancelling will abandon the entire cart, including devices, plans and services.',
  NO: 'No',
  CANCEL: 'cancel',
  BTN_SECONDARY: 'btn btn-secondary',
  YES: 'Yes',
  SUBMIT: 'submit',
  BTN_PRIMARY: 'btn btn-primary',
};

export const ORDER_STATUS = {
  INPROCESS: 'INPROCESS',
  COMPLETE: 'COMPLETE',
};

export const VIEW_STATEMENT = {
  URL: 'url',
  CONTENT: 'Content',
  WEB: 'web',
  RECEIPT: 'RECEIPT',
  TRANSACTION_CONFIRMATION: 'TRANSACTION_CONFIRMATION',
  SHIPPING_LABEL: 'shippingLabel',
};
